import { ui } from '../../styles/ui'

export default function LoadingState({ text = 'Loading...' }) {
  return (
    <div className={ui.states.loading} role="status" aria-live="polite">
      <div className="flex items-center gap-2">
        <span className={ui.feedback.spinner} />
        <span>{text}</span>
      </div>
    </div>
  )
}
